module.exports = __webpack_public_path__ + "img/35.3661d53a.jpg";